import { render, staticRenderFns } from "./Keywords.vue?vue&type=template&id=07d07e35&scoped=true"
import script from "./Keywords.ts?vue&type=script&lang=ts"
export * from "./Keywords.ts?vue&type=script&lang=ts"
import style0 from "./Keywords.vue?vue&type=style&index=0&id=07d07e35&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d07e35",
  null
  
)

export default component.exports